const AppleIcon = ({ className }: { className: string }) => (
  <svg
    className={`app ${className}`}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.1 19.16C19.69 18.26 19.91 17.8 20.36 16.79C17.04 15.53 16.51 10.8 19.79 8.98999C18.79 7.72999 17.38 7 16.05 7C15.09 7 14.43 7.25001 13.84 7.48001C13.34 7.67001 12.89 7.84 12.33 7.84C11.73 7.84 11.2 7.65001 10.64 7.45001C10.03 7.23001 9.39 7 8.59 7C7.1 7 5.51001 7.91 4.50001 9.47C3.08001 11.67 3.33001 15.79 5.62001 19.31C6.44001 20.57 7.54001 21.98 8.97001 22C9.57001 22.01 9.96 21.83 10.39 21.64C10.88 21.42 11.41 21.18 12.34 21.18C13.27 21.17 13.79 21.42 14.28 21.64C14.7 21.83 15.08 22.01 15.67 22C17.12 21.98 18.28 20.42 19.1 19.16Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.84 2C16 3.1 15.55 4.19001 14.96 4.95001C14.33 5.77001 13.23 6.41 12.17 6.37C11.98 5.31 12.47 4.21999 13.07 3.48999C13.74 2.68999 14.87 2.07 15.84 2Z'
    />
  </svg>
)
export default AppleIcon
